import React from 'react';

const Ci50Graph = ({ ci50Value, ranges }) => {
  const graphMax = 8;
  const getCi50Colour = (value) => {
    if (isNaN(value)) return 'bg-gray-500';
    if (value <= ranges.perProtocol.max) return 'bg-green-500';
    if (value <= ranges.acceptable.max) return 'bg-yellow-500';
    return 'bg-red-500';
  };

  const getCi50Label = (value) => {
    if (isNaN(value)) return 'N/A';
    if (value <= ranges.perProtocol.max) return 'Per-Protocol';
    if (value <= ranges.acceptable.max) return 'Acceptable';
    return 'Unacceptable';
  };
  const markerPosition = Math.min(Math.max(ci50Value, 0), graphMax);

  return (
    <div className="flex flex-col items-center justify-center p-4 md:p-6 bg-gray-100 dark:bg-gray-800 rounded-xl shadow-inner">
      <div className="w-full max-w-xl">
        <div className="relative h-12">
          <div className="absolute top-0 bottom-0 rounded-r-full bg-red-600/70" style={{ left: `${(ranges.acceptable.max / graphMax) * 100}%`, right: `0%` }}></div>
          <div className="absolute top-0 bottom-0 bg-yellow-600/70" style={{ left: `${(ranges.perProtocol.max / graphMax) * 100}%`, right: `${100 - (ranges.acceptable.max / graphMax) * 100}%` }}></div>
          <div className="absolute top-0 bottom-0 rounded-l-full bg-green-600/70" style={{ left: `0%`, right: `${100 - (ranges.perProtocol.max / graphMax) * 100}%` }}></div>
          {!isNaN(ci50Value) && (
            <div className={`absolute top-0 bottom-0 w-1 shadow-lg transform transition-all duration-500 ease-in-out ${getCi50Colour(ci50Value)}`} style={{ left: `${(markerPosition / graphMax) * 100}%` }}>
              <div className="absolute -top-12 -left-8 w-20 text-center text-sm font-semibold">
                <span className="text-sm font-bold text-gray-800 dark:text-gray-100">CI50: {ci50Value.toFixed(2)}</span>
                <p className={`text-xs mt-1 ${getCi50Colour(ci50Value).replace('bg', 'text')}`}>{getCi50Label(ci50Value)}</p>
              </div>
            </div>
          )}
        </div>
        <div className="mt-4 flex justify-between text-xs md:text-sm font-semibold text-gray-500 dark:text-gray-400">
          {[...Array(9).keys()].map(i => (<span key={i}>{i}.0</span>))}
        </div>
        <div className="mt-2 text-center text-xs text-gray-600 dark:text-gray-500">(Ranges are dynamically calculated based on the entered PTV volume)</div>
      </div>
    </div>
  );
};

export default Ci50Graph;